import { Controller } from 'stimulus';

export default class AdministrationController extends Controller {
  submitForm() {
    Rails.fire(this.element, 'submit');
  }
}
